// @flow
import * as React from 'react'

import './Layout.module.scss'

type Props = {
  children: React.Node,
}

export default function Layout(props: Props) {
  return <div styleName="root">{props.children}</div>
}
